import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Blade, Button } from "rhombus-react";
import { useTooltipRebuild } from "hooks/useTooltipRebuild";
import ContentFeedItems from "widgets/grid/cells/ContentFeeds/ContentFeedItems";

import { SOURCE_TYPE_DISPLAY_VALUE, buildContentFeedUrl } from "utils/ContentFeedFormat";

import "./ViewContentFeedDetailsModal.css";

export default function ViewContentFeedDetailsModal({ onClose }) {
	const location = useLocation();
	const contentFeedName = location.state?.contentFeedName;
	const format = location.state?.format;
	const url = location.state?.url;
	const itemKey = location.state?.itemKey;
	const eligibleItems = location.state?.eligibleItems;
	const totalItems = location.state?.totalItems;
	const lastSync = location.state?.lastSync;
	const mapping = location.state?.mapping;
	useTooltipRebuild();
	const userLocale = useSelector(state => state.you?.locale || 'en-us');

	function formatDate(dateString) {
		if (!dateString) {
			return '';
		}
		const date = new Date(dateString);
		const now = new Date();
		const isToday = date.toDateString() === now.toDateString();

		if (isToday) {
			return `Today at ${date.toLocaleTimeString(userLocale, {
				hour: "numeric",
				minute: "2-digit",
				hour12: true,
			})}`;
		}

		return date.toLocaleDateString(userLocale, {
			month: "short",
			day: "numeric",
			year: "numeric",
			hour: "numeric",
			minute: "2-digit",
		});
	}

	function renderContent() {
		const mappingCount = Object.keys(mapping?._mappings || {}).length;
		const typeUrl = buildContentFeedUrl({ format, url, itemKey });
		const typeLabel = SOURCE_TYPE_DISPLAY_VALUE[format];

		return (
			<div className="view-content-feed-details-body">

				<div className="detail-row">
					<label className="detail-label">Type:</label>
					<span className="detail-value">
						<a
							href={typeUrl}
							target="_blank"
							rel="noopener noreferrer"
							className="detail-link"
						>
							{typeLabel}
						</a>
					</span>
				</div>

				<div className="detail-row">
					<label className="detail-label">Items:</label>
					<span className="detail-value">
						<ContentFeedItems dependentValues={{ eligibleItems, totalItems }} />
					</span>
				</div>

				<div className="detail-row">
					<label className="detail-label">Last update:</label>
					<span className="detail-value">{formatDate(lastSync)}</span>
				</div>

				<div className="detail-row">
					<label className="detail-label">Mappings:</label>
					<span className="detail-value">{mappingCount}</span>
				</div>
			</div>
		);
	}

	function renderFooter() {
		return (
			<Button theme="blue" onClick={onClose}>
				Close
			</Button>
		);
	}

	return (
		<Blade
			type="modal"
			title={`Details - ${contentFeedName}`}
			className="view-content-feed-details-modal"
			allowFullScreen={false}
			bladeProps={{ verticallyCenter: true }}
			xClose
			onClose={onClose}
			renderContent={renderContent}
			renderFooter={renderFooter}
			setAppTitle={false}
		/>
	);
}

ViewContentFeedDetailsModal.displayName = "ViewContentFeedDetailsModal";

ViewContentFeedDetailsModal.propTypes = {
	onClose: PropTypes.func.isRequired,
};

